import { render, staticRenderFns } from "./LogisticPlaceOrder.vue?vue&type=template&id=386af99c&"
import script from "./LogisticPlaceOrder.vue?vue&type=script&lang=js&"
export * from "./LogisticPlaceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports